import { render, staticRenderFns } from "./AddRecipients.vue?vue&type=template&id=c32b56fa&scoped=true"
import script from "./AddRecipients.vue?vue&type=script&lang=js"
export * from "./AddRecipients.vue?vue&type=script&lang=js"
import style0 from "./AddRecipients.vue?vue&type=style&index=0&id=c32b56fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32b56fa",
  null
  
)

export default component.exports